import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, inject, forwardRef, numberAttribute, booleanAttribute, Input, ViewEncapsulation, Component, EventEmitter, ContentChildren, ViewChild, ContentChild, Output, Optional, ChangeDetectionStrategy, NgModule } from '@angular/core';
import * as i2 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { find, hasClass, findSingle, focus, removeAccents, resolveFieldData } from '@primeuix/utils';
import * as i3 from 'primeng/api';
import { SharedModule, TranslationKeys, PrimeTemplate } from 'primeng/api';
import { BaseComponent } from 'primeng/basecomponent';
import { Checkbox } from 'primeng/checkbox';
import { IconField } from 'primeng/iconfield';
import { ChevronRightIcon, ChevronDownIcon, SpinnerIcon, SearchIcon } from 'primeng/icons';
import { InputIcon } from 'primeng/inputicon';
import { InputText } from 'primeng/inputtext';
import { Ripple } from 'primeng/ripple';
import { Scroller } from 'primeng/scroller';
import { BaseStyle } from 'primeng/base';
import * as i4 from 'primeng/autofocus';
import { AutoFocusModule } from 'primeng/autofocus';
const _c0 = a0 => ({
  height: a0
});
const _c1 = a0 => ({
  "p-tree-node-droppoint-active": a0
});
const _c2 = (a0, a1) => ({
  $implicit: a0,
  loading: a1
});
const _c3 = (a0, a1) => ({
  $implicit: a0,
  partialSelected: a1,
  class: "p-tree-node-checkbox"
});
const _c4 = a0 => ({
  $implicit: a0
});
function UITreeNode_Conditional_0_li_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 11);
    i0.ɵɵlistener("drop", function UITreeNode_Conditional_0_li_0_Template_li_drop_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onDropPoint($event, -1));
    })("dragover", function UITreeNode_Conditional_0_li_0_Template_li_dragover_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onDropPointDragOver($event));
    })("dragenter", function UITreeNode_Conditional_0_li_0_Template_li_dragenter_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onDropPointDragEnter($event, -1));
    })("dragleave", function UITreeNode_Conditional_0_li_0_Template_li_dragleave_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onDropPointDragLeave($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1, ctx_r2.draghoverPrev));
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function UITreeNode_Conditional_0_ng_container_4_ng_container_1_ChevronRightIcon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ChevronRightIcon", 13);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-tree-node-toggle-icon");
  }
}
function UITreeNode_Conditional_0_ng_container_4_ng_container_1_ChevronDownIcon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ChevronDownIcon", 13);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-tree-node-toggle-icon");
  }
}
function UITreeNode_Conditional_0_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, UITreeNode_Conditional_0_ng_container_4_ng_container_1_ChevronRightIcon_1_Template, 1, 1, "ChevronRightIcon", 12)(2, UITreeNode_Conditional_0_ng_container_4_ng_container_1_ChevronDownIcon_2_Template, 1, 1, "ChevronDownIcon", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.node.expanded);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.node.expanded);
  }
}
function UITreeNode_Conditional_0_ng_container_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "SpinnerIcon", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("styleClass", "pi-spin p-tree-node-toggle-icon");
  }
}
function UITreeNode_Conditional_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, UITreeNode_Conditional_0_ng_container_4_ng_container_1_Template, 3, 2, "ng-container", 5)(2, UITreeNode_Conditional_0_ng_container_4_ng_container_2_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.node.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.loadingMode === "icon" && ctx_r2.node.loading);
  }
}
function UITreeNode_Conditional_0_span_5_1_ng_template_0_Template(rf, ctx) {}
function UITreeNode_Conditional_0_span_5_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UITreeNode_Conditional_0_span_5_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UITreeNode_Conditional_0_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtemplate(1, UITreeNode_Conditional_0_span_5_1_Template, 1, 0, null, 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.tree.togglerIconTemplate || ctx_r2.tree._togglerIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c2, ctx_r2.node.expanded, ctx_r2.node.loading));
  }
}
function UITreeNode_Conditional_0_p_checkbox_6_ng_container_1_ng_template_1_0_ng_template_0_Template(rf, ctx) {}
function UITreeNode_Conditional_0_p_checkbox_6_ng_container_1_ng_template_1_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UITreeNode_Conditional_0_p_checkbox_6_ng_container_1_ng_template_1_0_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UITreeNode_Conditional_0_p_checkbox_6_ng_container_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UITreeNode_Conditional_0_p_checkbox_6_ng_container_1_ng_template_1_0_Template, 1, 0, null, 15);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.tree.checkboxIconTemplate || ctx_r2.tree._checkboxIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c3, ctx_r2.isSelected(), ctx_r2.node.partialSelected));
  }
}
function UITreeNode_Conditional_0_p_checkbox_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, UITreeNode_Conditional_0_p_checkbox_6_ng_container_1_ng_template_1_Template, 1, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
}
function UITreeNode_Conditional_0_p_checkbox_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-checkbox", 16);
    i0.ɵɵlistener("click", function UITreeNode_Conditional_0_p_checkbox_6_Template_p_checkbox_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵtemplate(1, UITreeNode_Conditional_0_p_checkbox_6_ng_container_1_Template, 3, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngModel", ctx_r2.isSelected())("binary", true)("indeterminate", ctx_r2.node.partialSelected)("disabled", ctx_r2.node.selectable === false)("variant", (ctx_r2.tree == null ? null : ctx_r2.tree.config.inputStyle()) === "filled" || (ctx_r2.tree == null ? null : ctx_r2.tree.config.inputVariant()) === "filled" ? "filled" : "outlined")("tabindex", -1);
    i0.ɵɵattribute("data-p-partialchecked", ctx_r2.node.partialSelected);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.tree.checkboxIconTemplate || ctx_r2.tree._checkboxIconTemplate);
  }
}
function UITreeNode_Conditional_0_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r2.getIcon());
  }
}
function UITreeNode_Conditional_0_span_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.node.label);
  }
}
function UITreeNode_Conditional_0_span_10_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UITreeNode_Conditional_0_span_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, UITreeNode_Conditional_0_span_10_ng_container_1_Template, 1, 0, "ng-container", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.tree.getTemplateForNode(ctx_r2.node))("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c4, ctx_r2.node));
  }
}
function UITreeNode_Conditional_0_ul_11_p_treeNode_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-treeNode", 19);
  }
  if (rf & 2) {
    const childNode_r5 = ctx.$implicit;
    const firstChild_r6 = ctx.first;
    const lastChild_r7 = ctx.last;
    const index_r8 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("node", childNode_r5)("parentNode", ctx_r2.node)("firstChild", firstChild_r6)("lastChild", lastChild_r7)("index", index_r8)("itemSize", ctx_r2.itemSize)("level", ctx_r2.level + 1)("loadingMode", ctx_r2.loadingMode);
  }
}
function UITreeNode_Conditional_0_ul_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 17);
    i0.ɵɵtemplate(1, UITreeNode_Conditional_0_ul_11_p_treeNode_1_Template, 1, 8, "p-treeNode", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("display", ctx_r2.node.expanded ? "flex" : "none");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.node.children)("ngForTrackBy", ctx_r2.tree.trackBy.bind(ctx_r2));
  }
}
function UITreeNode_Conditional_0_li_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 11);
    i0.ɵɵlistener("drop", function UITreeNode_Conditional_0_li_12_Template_li_drop_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onDropPoint($event, 1));
    })("dragover", function UITreeNode_Conditional_0_li_12_Template_li_dragover_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onDropPointDragOver($event));
    })("dragenter", function UITreeNode_Conditional_0_li_12_Template_li_dragenter_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onDropPointDragEnter($event, 1));
    })("dragleave", function UITreeNode_Conditional_0_li_12_Template_li_dragleave_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onDropPointDragLeave($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1, ctx_r2.draghoverNext));
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function UITreeNode_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, UITreeNode_Conditional_0_li_0_Template, 1, 4, "li", 1);
    i0.ɵɵelementStart(1, "li", 2);
    i0.ɵɵlistener("keydown", function UITreeNode_Conditional_0_Template_li_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onKeyDown($event));
    });
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵlistener("click", function UITreeNode_Conditional_0_Template_div_click_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onNodeClick($event));
    })("contextmenu", function UITreeNode_Conditional_0_Template_div_contextmenu_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onNodeRightClick($event));
    })("dblclick", function UITreeNode_Conditional_0_Template_div_dblclick_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onNodeDblClick($event));
    })("touchend", function UITreeNode_Conditional_0_Template_div_touchend_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onNodeTouchEnd());
    })("drop", function UITreeNode_Conditional_0_Template_div_drop_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onDropNode($event));
    })("dragover", function UITreeNode_Conditional_0_Template_div_dragover_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onDropNodeDragOver($event));
    })("dragenter", function UITreeNode_Conditional_0_Template_div_dragenter_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onDropNodeDragEnter($event));
    })("dragleave", function UITreeNode_Conditional_0_Template_div_dragleave_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onDropNodeDragLeave($event));
    })("dragstart", function UITreeNode_Conditional_0_Template_div_dragstart_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onDragStart($event));
    })("dragend", function UITreeNode_Conditional_0_Template_div_dragend_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onDragStop($event));
    });
    i0.ɵɵelementStart(3, "button", 4);
    i0.ɵɵlistener("click", function UITreeNode_Conditional_0_Template_button_click_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggle($event));
    });
    i0.ɵɵtemplate(4, UITreeNode_Conditional_0_ng_container_4_Template, 3, 2, "ng-container", 5)(5, UITreeNode_Conditional_0_span_5_Template, 2, 5, "span", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, UITreeNode_Conditional_0_p_checkbox_6_Template, 2, 8, "p-checkbox", 7)(7, UITreeNode_Conditional_0_span_7_Template, 1, 2, "span", 8);
    i0.ɵɵelementStart(8, "span", 9);
    i0.ɵɵtemplate(9, UITreeNode_Conditional_0_span_9_Template, 2, 1, "span", 5)(10, UITreeNode_Conditional_0_span_10_Template, 2, 4, "span", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(11, UITreeNode_Conditional_0_ul_11_Template, 2, 4, "ul", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, UITreeNode_Conditional_0_li_12_Template, 1, 4, "li", 1);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.tree.droppableNodes);
    i0.ɵɵadvance();
    i0.ɵɵstyleMap(ctx_r2.node.style);
    i0.ɵɵclassMap(ctx_r2.node.styleClass);
    i0.ɵɵproperty("ngClass", ctx_r2.nodeClass)("ngStyle", i0.ɵɵpureFunction1(29, _c0, ctx_r2.itemSize + "px"));
    i0.ɵɵattribute("aria-label", ctx_r2.node.label)("aria-checked", ctx_r2.checked)("aria-setsize", ctx_r2.node.children ? ctx_r2.node.children.length : 0)("aria-selected", ctx_r2.selected)("aria-expanded", ctx_r2.node.expanded)("aria-posinset", ctx_r2.index + 1)("aria-level", ctx_r2.level + 1)("tabindex", ctx_r2.index === 0 ? 0 : -1)("data-id", ctx_r2.node.key);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("padding-left", ctx_r2.level * ctx_r2.indentation + "rem");
    i0.ɵɵproperty("ngClass", ctx_r2.nodeContentClass)("draggable", ctx_r2.tree.draggableNodes);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-pc-section", "toggler");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.tree.togglerIconTemplate && !ctx_r2.tree._togglerIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.tree.togglerIconTemplate || ctx_r2.tree._togglerIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.tree.selectionMode == "checkbox");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.node.icon || ctx_r2.node.expandedIcon || ctx_r2.node.collapsedIcon);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.tree.getTemplateForNode(ctx_r2.node));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.tree.getTemplateForNode(ctx_r2.node));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.tree.virtualScroll && ctx_r2.node.children && ctx_r2.node.expanded);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.tree.droppableNodes && ctx_r2.lastChild);
  }
}
const _c5 = ["filter"];
const _c6 = ["node"];
const _c7 = ["header"];
const _c8 = ["footer"];
const _c9 = ["loader"];
const _c10 = ["empty"];
const _c11 = ["togglericon"];
const _c12 = ["checkboxicon"];
const _c13 = ["loadingicon"];
const _c14 = ["filtericon"];
const _c15 = ["scroller"];
const _c16 = ["wrapper"];
const _c17 = a0 => ({
  options: a0
});
function Tree_div_1_i_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("p-tree-loading-icon pi-spin " + ctx_r0.loadingIcon);
  }
}
function Tree_div_1_ng_container_2_SpinnerIcon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "SpinnerIcon", 16);
  }
  if (rf & 2) {
    i0.ɵɵproperty("spin", true)("styleClass", "p-tree-loading-icon");
  }
}
function Tree_div_1_ng_container_2_span_2_1_ng_template_0_Template(rf, ctx) {}
function Tree_div_1_ng_container_2_span_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Tree_div_1_ng_container_2_span_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function Tree_div_1_ng_container_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtemplate(1, Tree_div_1_ng_container_2_span_2_1_Template, 1, 0, null, 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.loadingIconTemplate || ctx_r0._loadingIconTemplate);
  }
}
function Tree_div_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Tree_div_1_ng_container_2_SpinnerIcon_1_Template, 1, 2, "SpinnerIcon", 14)(2, Tree_div_1_ng_container_2_span_2_Template, 2, 1, "span", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.loadingIconTemplate && !ctx_r0._loadingIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.loadingIconTemplate || ctx_r0._loadingIconTemplate);
  }
}
function Tree_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, Tree_div_1_i_1_Template, 1, 2, "i", 13)(2, Tree_div_1_ng_container_2_Template, 3, 2, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.loadingIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.loadingIcon);
  }
}
function Tree_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Tree_Conditional_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Tree_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Tree_Conditional_3_ng_container_0_Template, 1, 0, "ng-container", 18);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.filterTemplate || ctx_r0._filterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c4, ctx_r0.filterOptions));
  }
}
function Tree_Conditional_4_p_iconField_0_SearchIcon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "SearchIcon", 21);
  }
}
function Tree_Conditional_4_p_iconField_0_span_5_1_ng_template_0_Template(rf, ctx) {}
function Tree_Conditional_4_p_iconField_0_span_5_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Tree_Conditional_4_p_iconField_0_span_5_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function Tree_Conditional_4_p_iconField_0_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, Tree_Conditional_4_p_iconField_0_span_5_1_Template, 1, 0, null, 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.filterIconTemplate || ctx_r0._filterIconTemplate);
  }
}
function Tree_Conditional_4_p_iconField_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-iconField")(1, "input", 19, 0);
    i0.ɵɵlistener("keydown.enter", function Tree_Conditional_4_p_iconField_0_Template_input_keydown_enter_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      return i0.ɵɵresetView($event.preventDefault());
    })("input", function Tree_Conditional_4_p_iconField_0_Template_input_input_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0._filter($event.target.value));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-inputIcon");
    i0.ɵɵtemplate(4, Tree_Conditional_4_p_iconField_0_SearchIcon_4_Template, 1, 0, "SearchIcon", 20)(5, Tree_Conditional_4_p_iconField_0_span_5_Template, 2, 1, "span", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("pAutoFocus", ctx_r0.filterInputAutoFocus);
    i0.ɵɵattribute("placeholder", ctx_r0.filterPlaceholder);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.filterIconTemplate && !ctx_r0._filterIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.filterIconTemplate || ctx_r0._filterIconTemplate);
  }
}
function Tree_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Tree_Conditional_4_p_iconField_0_Template, 6, 4, "p-iconField", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.filter);
  }
}
function Tree_ng_container_5_p_scroller_1_ng_template_2_ul_0_p_treeNode_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-treeNode", 27, 3);
  }
  if (rf & 2) {
    const rowNode_r4 = ctx.$implicit;
    const firstChild_r5 = ctx.first;
    const lastChild_r6 = ctx.last;
    const index_r7 = ctx.index;
    const scrollerOptions_r8 = i0.ɵɵnextContext(2).options;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("level", rowNode_r4.level)("rowNode", rowNode_r4)("node", rowNode_r4.node)("parentNode", rowNode_r4.parent)("firstChild", firstChild_r5)("lastChild", lastChild_r6)("index", ctx_r0.getIndex(scrollerOptions_r8, index_r7))("itemSize", scrollerOptions_r8.itemSize)("indentation", ctx_r0.indentation)("loadingMode", ctx_r0.loadingMode);
  }
}
function Tree_ng_container_5_p_scroller_1_ng_template_2_ul_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 25);
    i0.ɵɵtemplate(1, Tree_ng_container_5_p_scroller_1_ng_template_2_ul_0_p_treeNode_1_Template, 2, 10, "p-treeNode", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    const items_r10 = ctx_r8.$implicit;
    const scrollerOptions_r8 = ctx_r8.options;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleMap(scrollerOptions_r8.contentStyle);
    i0.ɵɵproperty("ngClass", scrollerOptions_r8.contentStyleClass);
    i0.ɵɵattribute("aria-label", ctx_r0.ariaLabel)("aria-labelledby", ctx_r0.ariaLabelledBy);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", items_r10)("ngForTrackBy", ctx_r0.trackBy);
  }
}
function Tree_ng_container_5_p_scroller_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Tree_ng_container_5_p_scroller_1_ng_template_2_ul_0_Template, 2, 7, "ul", 24);
  }
  if (rf & 2) {
    const items_r10 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", items_r10);
  }
}
function Tree_ng_container_5_p_scroller_1_ng_container_4_ng_template_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Tree_ng_container_5_p_scroller_1_ng_container_4_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Tree_ng_container_5_p_scroller_1_ng_container_4_ng_template_1_ng_container_0_Template, 1, 0, "ng-container", 18);
  }
  if (rf & 2) {
    const scrollerOptions_r11 = ctx.options;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.loaderTemplate || ctx_r0._loaderTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c17, scrollerOptions_r11));
  }
}
function Tree_ng_container_5_p_scroller_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Tree_ng_container_5_p_scroller_1_ng_container_4_ng_template_1_Template, 1, 4, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
}
function Tree_ng_container_5_p_scroller_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-scroller", 23, 1);
    i0.ɵɵlistener("onScroll", function Tree_ng_container_5_p_scroller_1_Template_p_scroller_onScroll_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onScroll.emit($event));
    })("onScrollIndexChange", function Tree_ng_container_5_p_scroller_1_Template_p_scroller_onScrollIndexChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onScrollIndexChange.emit($event));
    })("onLazyLoad", function Tree_ng_container_5_p_scroller_1_Template_p_scroller_onLazyLoad_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onLazyLoad.emit($event));
    });
    i0.ɵɵtemplate(2, Tree_ng_container_5_p_scroller_1_ng_template_2_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(4, Tree_ng_container_5_p_scroller_1_ng_container_4_Template, 3, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(9, _c0, ctx_r0.scrollHeight !== "flex" ? ctx_r0.scrollHeight : undefined));
    i0.ɵɵproperty("items", ctx_r0.serializedValue)("tabindex", -1)("scrollHeight", ctx_r0.scrollHeight !== "flex" ? undefined : "100%")("itemSize", ctx_r0.virtualScrollItemSize || ctx_r0._virtualNodeHeight)("lazy", ctx_r0.lazy)("options", ctx_r0.virtualScrollOptions);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.loaderTemplate || ctx_r0._loaderTemplate);
  }
}
function Tree_ng_container_5_ng_container_2_ul_3_p_treeNode_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-treeNode", 32);
  }
  if (rf & 2) {
    const node_r12 = ctx.$implicit;
    const firstChild_r13 = ctx.first;
    const lastChild_r14 = ctx.last;
    const index_r15 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("node", node_r12)("firstChild", firstChild_r13)("lastChild", lastChild_r14)("index", index_r15)("level", 0)("loadingMode", ctx_r0.loadingMode);
  }
}
function Tree_ng_container_5_ng_container_2_ul_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 30);
    i0.ɵɵtemplate(1, Tree_ng_container_5_ng_container_2_ul_3_p_treeNode_1_Template, 1, 6, "p-treeNode", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-label", ctx_r0.ariaLabel)("aria-labelledby", ctx_r0.ariaLabelledBy);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.getRootNode())("ngForTrackBy", ctx_r0.trackBy.bind(ctx_r0));
  }
}
function Tree_ng_container_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 28, 5);
    i0.ɵɵtemplate(3, Tree_ng_container_5_ng_container_2_ul_3_Template, 2, 4, "ul", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("max-height", ctx_r0.scrollHeight);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.getRootNode());
  }
}
function Tree_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Tree_ng_container_5_p_scroller_1_Template, 5, 11, "p-scroller", 22)(2, Tree_ng_container_5_ng_container_2_Template, 4, 3, "ng-container", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.virtualScroll);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.virtualScroll);
  }
}
function Tree_div_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.emptyMessageLabel, " ");
  }
}
function Tree_div_6_2_ng_template_0_Template(rf, ctx) {}
function Tree_div_6_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Tree_div_6_2_ng_template_0_Template, 0, 0, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
  }
}
function Tree_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtemplate(1, Tree_div_6_ng_container_1_Template, 2, 1, "ng-container", 34)(2, Tree_div_6_2_Template, 2, 0, null, 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.emptyMessageTemplate && !ctx_r0._emptyMessageTemplate)("ngIfElse", ctx_r0.emptyFilter);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.emptyMessageTemplate || ctx_r0._emptyMessageTemplate);
  }
}
function Tree_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const theme = ({
  dt
}) => `
.p-tree {
    background: ${dt('tree.background')};
    color: ${dt('tree.color')};
    padding: ${dt('tree.padding')};
}

.p-tree-root-children,
.p-tree-node-children {
    display: flex;
    list-style-type: none;
    flex-direction: column;
    margin: 0;
    gap: ${dt('tree.gap')};
}

.p-tree-root-children {
    padding: 0;
    padding-block-start: ${dt('tree.gap')};
}

.p-tree-node-children {
    padding-block-start: ${dt('tree.gap')};
    padding-inline-start: ${dt('tree.indent')};
}

.p-tree-node {
    padding: 0;
    outline: 0 none;
}

.p-tree-node-content {
    border-radius: ${dt('tree.node.border.radius')};
    padding: ${dt('tree.node.padding')};
    display: flex;
    align-items: center;
    outline-color: transparent;
    color: ${dt('tree.node.color')};
    gap: ${dt('tree.node.gap')};
    transition: background ${dt('tree.transition.duration')}, color ${dt('tree.transition.duration')}, outline-color ${dt('tree.transition.duration')}, box-shadow ${dt('tree.transition.duration')};
}

.p-tree-node:focus-visible > .p-tree-node-content {
    box-shadow: ${dt('tree.node.focus.ring.shadow')};
    outline: ${dt('tree.node.focus.ring.width')} ${dt('tree.node.focus.ring.style')} ${dt('tree.node.focus.ring.color')};
    outline-offset: ${dt('tree.node.focus.ring.offset')};
}

.p-tree-node-content.p-tree-node-selectable:not(.p-tree-node-selected):hover {
    background: ${dt('tree.node.hover.background')};
    color: ${dt('tree.node.hover.color')};
}

.p-tree-node-content.p-tree-node-selectable:not(.p-tree-node-selected):hover .p-tree-node-icon {
    color: ${dt('tree.node.icon.hover.color')};
}

.p-tree-node-content.p-tree-node-selected {
    background: ${dt('tree.node.selected.background')};
    color: ${dt('tree.node.selected.color')};
}

.p-tree-node-content.p-tree-node-selected .p-tree-node-toggle-button {
    color: inherit;
}

.p-tree-node-toggle-button {
    cursor: pointer;
    user-select: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    flex-shrink: 0;
    width: ${dt('tree.node.toggle.button.size')};
    height: ${dt('tree.node.toggle.button.size')};
    color: ${dt('tree.node.toggle.button.color')};
    border: 0 none;
    background: transparent;
    border-radius: ${dt('tree.node.toggle.button.border.radius')};
    transition: background ${dt('tree.transition.duration')}, color ${dt('tree.transition.duration')}, border-color ${dt('tree.transition.duration')}, outline-color ${dt('tree.transition.duration')}, box-shadow ${dt('tree.transition.duration')};
    outline-color: transparent;
    padding: 0;
}

.p-tree-node-toggle-button:enabled:hover {
    background: ${dt('tree.node.toggle.button.hover.background')};
    color: ${dt('tree.node.toggle.button.hover.color')};
}

.p-tree-node-content.p-tree-node-selected .p-tree-node-toggle-button:hover {
    background: ${dt('tree.node.toggle.button.selected.hover.background')};
    color: ${dt('tree.node.toggle.button.selected.hover.color')};
}

.p-tree-root {
    overflow: auto;
}

.p-tree-node-selectable {
    cursor: pointer;
    user-select: none;
}

.p-tree-node-leaf > .p-tree-node-content .p-tree-node-toggle-button {
    visibility: hidden;
}

.p-tree-node-icon {
    color: ${dt('tree.node.icon.color')};
    transition: color ${dt('tree.transition.duration')};
}

.p-tree-node-content.p-tree-node-selected .p-tree-node-icon {
    color: ${dt('tree.node.icon.selected.color')};
}

.p-tree-filter-input {
    width: 100%;
}

.p-tree-loading {
    position: relative;
    height: 100%;
}

.p-tree-loading-icon {
    font-size: ${dt('tree.loading.icon.size')};
    width: ${dt('tree.loading.icon.size')};
    height: ${dt('tree.loading.icon.size')};
}

.p-tree .p-tree-mask {
    position: absolute;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.p-tree-flex-scrollable {
    display: flex;
    flex: 1;
    height: 100%;
    flex-direction: column;
}

.p-tree-flex-scrollable .p-tree-root {
    flex: 1;
}

/* For PrimeNG */
.p-tree .p-tree-node-droppoint {
    height: 4px;
    list-style-type: none;
}

.p-tree .p-tree-node-droppoint-active {
    border: 0 none;
    background-color: ${dt('primary.color')};
}

.p-tree-node-content.p-tree-node-dragover {
    background: ${dt('tree.node.hover.background')};
    color: ${dt('tree.node.hover.color')};
}

.p-tree-node-content.p-tree-node-dragover .p-tree-node-icon {
    color: ${dt('tree.node.icon.hover.color')};
}

.p-tree-horizontal {
    width: auto;
    padding-inline-start: 0;
    padding-inline-end: 0;
    overflow: auto;
}

.p-tree.p-tree-horizontal table,
.p-tree.p-tree-horizontal tr,
.p-tree.p-tree-horizontal td {
    border-collapse: collapse;
    margin: 0;
    padding: 0;
    vertical-align: middle;
}

.p-tree-horizontal .p-tree-node-content {
    font-weight: normal;
    padding: 0.4em 1em 0.4em 0.2em;
    display: flex;
    align-items: center;
}

.p-tree-horizontal .p-tree-node-parent .p-tree-node-content {
    font-weight: normal;
    white-space: nowrap;
}

.p-tree.p-tree-horizontal .p-tree-node.p-tree-node-leaf,
.p-tree.p-tree-horizontal .p-tree-node.p-tree-node-collapsed {
    padding-inline-end: 0;
}

.p-tree.p-tree-horizontal .p-tree-node-children {
    padding: 0;
    margin: 0;
}

.p-tree.p-tree-horizontal .p-tree-node-connector {
    width: 1px;
}

.p-tree.p-tree-horizontal .p-tree-node-connector-table {
    height: 100%;
    width: 1px;
}

.p-tree.p-tree-horizontal table {
    height: 0;
}
`;
const classes = {
  root: ({
    instance
  }) => ({
    'p-tree p-component': true,
    'p-tree-selectable': instance.selectionMode != null,
    'p-tree-loading': instance.loading,
    'p-tree-flex-scrollable': instance.scrollHeight === 'flex',
    'p-tree-node-dragover': instance.dragHover
  }),
  mask: 'p-tree-mask p-overlay-mask',
  loadingIcon: 'p-tree-loading-icon',
  pcFilterInput: 'p-tree-filter-input',
  wrapper: 'p-tree-root',
  //TODO: discuss
  rootChildren: 'p-tree-root-children',
  node: ({
    instance
  }) => ({
    'p-tree-node': true,
    'p-tree-node-leaf': instance.isLeaf()
  }),
  nodeContent: ({
    instance
  }) => ({
    'p-tree-node-content': true,
    [instance.styleClass]: !!instance.styleClass,
    'p-tree-node-selectable': instance.selectable,
    'p-tree-node-dragover': instance.draghoverNode,
    'p-tree-node-selected': instance.selectionMode === 'checkbox' && instance.tree.highlightOnSelect ? instance.checked : instance.selected
  }),
  nodeToggleButton: 'p-tree-node-toggle-button',
  nodeToggleIcon: 'p-tree-node-toggle-icon',
  nodeCheckbox: 'p-tree-node-checkbox',
  nodeIcon: 'p-tree-node-icon',
  nodeLabel: 'p-tree-node-label',
  nodeChildren: 'p-tree-node-children'
};
let TreeStyle = /*#__PURE__*/(() => {
  class TreeStyle extends BaseStyle {
    name = 'tree';
    theme = theme;
    classes = classes;
    static ɵfac = /* @__PURE__ */(() => {
      let ɵTreeStyle_BaseFactory;
      return function TreeStyle_Factory(__ngFactoryType__) {
        return (ɵTreeStyle_BaseFactory || (ɵTreeStyle_BaseFactory = i0.ɵɵgetInheritedFactory(TreeStyle)))(__ngFactoryType__ || TreeStyle);
      };
    })();
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TreeStyle,
      factory: TreeStyle.ɵfac
    });
  }
  return TreeStyle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 *
 * Tree is used to display hierarchical data.
 *
 * [Live Demo](https://www.primeng.org/tree/)
 *
 * @module treestyle
 *
 */
var TreeClasses = /*#__PURE__*/function (TreeClasses) {
  /**
   * Class name of the root element
   */
  TreeClasses["root"] = "p-tree";
  /**
   * Class name of the mask element
   */
  TreeClasses["mask"] = "p-tree-mask";
  /**
   * Class name of the loading icon element
   */
  TreeClasses["loadingIcon"] = "p-tree-loading-icon";
  /**
   * Class name of the filter input element
   */
  TreeClasses["pcFilterInput"] = "p-tree-filter-input";
  /**
   * Class name of the wrapper element
   */
  TreeClasses["wrapper"] = "p-tree-root";
  /**
   * Class name of the root children element
   */
  TreeClasses["rootChildren"] = "p-tree-root-children";
  /**
   * Class name of the node element
   */
  TreeClasses["node"] = "p-tree-node";
  /**
   * Class name of the node content element
   */
  TreeClasses["nodeContent"] = "p-tree-node-content";
  /**
   * Class name of the node toggle button element
   */
  TreeClasses["nodeToggleButton"] = "p-tree-node-toggle-button";
  /**
   * Class name of the node toggle icon element
   */
  TreeClasses["nodeToggleIcon"] = "p-tree-node-toggle-icon";
  /**
   * Class name of the node checkbox element
   */
  TreeClasses["nodeCheckbox"] = "p-tree-node-checkbox";
  /**
   * Class name of the node icon element
   */
  TreeClasses["nodeIcon"] = "p-tree-node-icon";
  /**
   * Class name of the node label element
   */
  TreeClasses["nodeLabel"] = "p-tree-node-label";
  /**
   * Class name of the node children element
   */
  TreeClasses["nodeChildren"] = "p-tree-node-children";
  return TreeClasses;
}(TreeClasses || {});
let UITreeNode = /*#__PURE__*/(() => {
  class UITreeNode extends BaseComponent {
    static ICON_CLASS = 'p-tree-node-icon ';
    rowNode;
    node;
    parentNode;
    root;
    index;
    firstChild;
    lastChild;
    level;
    indentation;
    itemSize;
    loadingMode;
    tree = inject(forwardRef(() => Tree));
    timeout;
    draghoverPrev;
    draghoverNext;
    draghoverNode;
    get selected() {
      return this.tree.selectionMode === 'single' || this.tree.selectionMode === 'multiple' ? this.isSelected() : undefined;
    }
    get checked() {
      return this.tree.selectionMode === 'checkbox' ? this.isSelected() : undefined;
    }
    get nodeClass() {
      return this.tree._componentStyle.classes.node({
        instance: this
      });
    }
    get nodeContentClass() {
      return this.tree._componentStyle.classes.nodeContent({
        instance: this
      });
    }
    get selectable() {
      return this.node.selectable === false ? false : this.tree.selectionMode != null;
    }
    ngOnInit() {
      super.ngOnInit();
      this.node.parent = this.parentNode;
      const nativeElement = this.tree.el.nativeElement;
      const pDialogWrapper = nativeElement.closest('p-dialog');
      if (this.parentNode && !pDialogWrapper) {
        this.setAllNodesTabIndexes();
        this.tree.syncNodeOption(this.node, this.tree.value, 'parent', this.tree.getNodeWithKey(this.parentNode.key, this.tree.value));
      }
    }
    getIcon() {
      let icon;
      if (this.node.icon) icon = this.node.icon;else icon = this.node.expanded && this.node.children && this.node.children?.length ? this.node.expandedIcon : this.node.collapsedIcon;
      return UITreeNode.ICON_CLASS + ' ' + icon + ' p-tree-node-icon';
    }
    isLeaf() {
      return this.tree.isNodeLeaf(this.node);
    }
    toggle(event) {
      if (this.node.expanded) this.collapse(event);else this.expand(event);
      event.stopPropagation();
    }
    expand(event) {
      this.node.expanded = true;
      if (this.tree.virtualScroll) {
        this.tree.updateSerializedValue();
        this.focusVirtualNode();
      }
      this.tree.onNodeExpand.emit({
        originalEvent: event,
        node: this.node
      });
    }
    collapse(event) {
      this.node.expanded = false;
      if (this.tree.virtualScroll) {
        this.tree.updateSerializedValue();
        this.focusVirtualNode();
      }
      this.tree.onNodeCollapse.emit({
        originalEvent: event,
        node: this.node
      });
    }
    onNodeClick(event) {
      this.tree.onNodeClick(event, this.node);
    }
    onNodeKeydown(event) {
      if (event.key === 'Enter') {
        this.tree.onNodeClick(event, this.node);
      }
    }
    onNodeTouchEnd() {
      this.tree.onNodeTouchEnd();
    }
    onNodeRightClick(event) {
      this.tree.onNodeRightClick(event, this.node);
    }
    onNodeDblClick(event) {
      this.tree.onNodeDblClick(event, this.node);
    }
    isSelected() {
      return this.tree.isSelected(this.node);
    }
    isSameNode(event) {
      return event.currentTarget && (event.currentTarget.isSameNode(event.target) || event.currentTarget.isSameNode(event.target.closest('[role="treeitem"]')));
    }
    onDropPoint(event, position) {
      event.preventDefault();
      let dragNode = this.tree.dragNode;
      let dragNodeIndex = this.tree.dragNodeIndex;
      let dragNodeScope = this.tree.dragNodeScope;
      let isValidDropPointIndex = this.tree.dragNodeTree === this.tree ? position === 1 || dragNodeIndex !== this.index - 1 : true;
      if (this.tree.allowDrop(dragNode, this.node, dragNodeScope) && isValidDropPointIndex) {
        let dropParams = {
          ...this.createDropPointEventMetadata(position)
        };
        if (this.tree.validateDrop) {
          this.tree.onNodeDrop.emit({
            originalEvent: event,
            dragNode: dragNode,
            dropNode: this.node,
            index: this.index,
            accept: () => {
              this.processPointDrop(dropParams);
            }
          });
        } else {
          this.processPointDrop(dropParams);
          this.tree.onNodeDrop.emit({
            originalEvent: event,
            dragNode: dragNode,
            dropNode: this.node,
            index: this.index
          });
        }
      }
      this.draghoverPrev = false;
      this.draghoverNext = false;
    }
    processPointDrop(event) {
      let newNodeList = event.dropNode.parent ? event.dropNode.parent.children : this.tree.value;
      event.dragNodeSubNodes.splice(event.dragNodeIndex, 1);
      let dropIndex = this.index;
      if (event.position < 0) {
        dropIndex = event.dragNodeSubNodes === newNodeList ? event.dragNodeIndex > event.index ? event.index : event.index - 1 : event.index;
        newNodeList.splice(dropIndex, 0, event.dragNode);
      } else {
        dropIndex = newNodeList.length;
        newNodeList.push(event.dragNode);
      }
      this.tree.dragDropService.stopDrag({
        node: event.dragNode,
        subNodes: event.dropNode.parent ? event.dropNode.parent.children : this.tree.value,
        index: event.dragNodeIndex
      });
    }
    createDropPointEventMetadata(position) {
      return {
        dragNode: this.tree.dragNode,
        dragNodeIndex: this.tree.dragNodeIndex,
        dragNodeSubNodes: this.tree.dragNodeSubNodes,
        dropNode: this.node,
        index: this.index,
        position: position
      };
    }
    onDropPointDragOver(event) {
      event.dataTransfer.dropEffect = 'move';
      event.preventDefault();
    }
    onDropPointDragEnter(event, position) {
      if (this.tree.allowDrop(this.tree.dragNode, this.node, this.tree.dragNodeScope)) {
        if (position < 0) this.draghoverPrev = true;else this.draghoverNext = true;
      }
    }
    onDropPointDragLeave(event) {
      this.draghoverPrev = false;
      this.draghoverNext = false;
    }
    onDragStart(event) {
      if (this.tree.draggableNodes && this.node.draggable !== false) {
        event.dataTransfer.setData('text', 'data');
        this.tree.dragDropService.startDrag({
          tree: this,
          node: this.node,
          subNodes: this.node?.parent ? this.node.parent.children : this.tree.value,
          index: this.index,
          scope: this.tree.draggableScope
        });
      } else {
        event.preventDefault();
      }
    }
    onDragStop(event) {
      this.tree.dragDropService.stopDrag({
        node: this.node,
        subNodes: this.node?.parent ? this.node.parent.children : this.tree.value,
        index: this.index
      });
    }
    onDropNodeDragOver(event) {
      event.dataTransfer.dropEffect = 'move';
      if (this.tree.droppableNodes) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
    onDropNode(event) {
      if (this.tree.droppableNodes && this.node?.droppable !== false) {
        let dragNode = this.tree.dragNode;
        if (this.tree.allowDrop(dragNode, this.node, this.tree.dragNodeScope)) {
          let dropParams = {
            ...this.createDropNodeEventMetadata()
          };
          if (this.tree.validateDrop) {
            this.tree.onNodeDrop.emit({
              originalEvent: event,
              dragNode: dragNode,
              dropNode: this.node,
              index: this.index,
              accept: () => {
                this.processNodeDrop(dropParams);
              }
            });
          } else {
            this.processNodeDrop(dropParams);
            this.tree.onNodeDrop.emit({
              originalEvent: event,
              dragNode: dragNode,
              dropNode: this.node,
              index: this.index
            });
          }
        }
      }
      event.preventDefault();
      event.stopPropagation();
      this.draghoverNode = false;
    }
    createDropNodeEventMetadata() {
      return {
        dragNode: this.tree.dragNode,
        dragNodeIndex: this.tree.dragNodeIndex,
        dragNodeSubNodes: this.tree.dragNodeSubNodes,
        dropNode: this.node
      };
    }
    processNodeDrop(event) {
      let dragNodeIndex = event.dragNodeIndex;
      event.dragNodeSubNodes.splice(dragNodeIndex, 1);
      if (event.dropNode.children) event.dropNode.children.push(event.dragNode);else event.dropNode.children = [event.dragNode];
      this.tree.dragDropService.stopDrag({
        node: event.dragNode,
        subNodes: event.dropNode.parent ? event.dropNode.parent.children : this.tree.value,
        index: dragNodeIndex
      });
    }
    onDropNodeDragEnter(event) {
      if (this.tree.droppableNodes && this.node?.droppable !== false && this.tree.allowDrop(this.tree.dragNode, this.node, this.tree.dragNodeScope)) {
        this.draghoverNode = true;
      }
    }
    onDropNodeDragLeave(event) {
      if (this.tree.droppableNodes) {
        let rect = event.currentTarget.getBoundingClientRect();
        if (event.x > rect.left + rect.width || event.x < rect.left || event.y >= Math.floor(rect.top + rect.height) || event.y < rect.top) {
          this.draghoverNode = false;
        }
      }
    }
    onKeyDown(event) {
      if (!this.isSameNode(event) || this.tree.contextMenu && this.tree.contextMenu.containerViewChild?.nativeElement.style.display === 'block') {
        return;
      }
      switch (event.code) {
        //down arrow
        case 'ArrowDown':
          this.onArrowDown(event);
          break;
        //up arrow
        case 'ArrowUp':
          this.onArrowUp(event);
          break;
        //right arrow
        case 'ArrowRight':
          this.onArrowRight(event);
          break;
        //left arrow
        case 'ArrowLeft':
          this.onArrowLeft(event);
          break;
        //enter
        case 'Enter':
        case 'Space':
        case 'NumpadEnter':
          this.onEnter(event);
          break;
        //tab
        case 'Tab':
          this.setAllNodesTabIndexes();
          break;
        default:
          //no op
          break;
      }
    }
    onArrowUp(event) {
      const nodeElement = event.target.getAttribute('data-pc-section') === 'toggler' ? event.target.closest('[role="treeitem"]') : event.target.parentElement;
      if (nodeElement.previousElementSibling) {
        this.focusRowChange(nodeElement, nodeElement.previousElementSibling, this.findLastVisibleDescendant(nodeElement.previousElementSibling));
      } else {
        let parentNodeElement = this.getParentNodeElement(nodeElement);
        if (parentNodeElement) {
          this.focusRowChange(nodeElement, parentNodeElement);
        }
      }
      event.preventDefault();
    }
    onArrowDown(event) {
      const nodeElement = event.target.getAttribute('data-pc-section') === 'toggler' ? event.target.closest('[role="treeitem"]') : event.target;
      const listElement = nodeElement.children[1];
      if (listElement && listElement.children.length > 0) {
        this.focusRowChange(nodeElement, listElement.children[0]);
      } else {
        if (nodeElement.parentElement.nextElementSibling) {
          this.focusRowChange(nodeElement, nodeElement.parentElement.nextElementSibling);
        } else {
          let nextSiblingAncestor = this.findNextSiblingOfAncestor(nodeElement.parentElement);
          if (nextSiblingAncestor) {
            this.focusRowChange(nodeElement, nextSiblingAncestor);
          }
        }
      }
      event.preventDefault();
    }
    onArrowRight(event) {
      if (!this.node?.expanded && !this.tree.isNodeLeaf(this.node)) {
        this.expand(event);
        event.currentTarget.tabIndex = -1;
        setTimeout(() => {
          this.onArrowDown(event);
        }, 1);
      }
      event.preventDefault();
    }
    onArrowLeft(event) {
      const nodeElement = event.target.getAttribute('data-pc-section') === 'toggler' ? event.target.closest('[role="treeitem"]') : event.target;
      if (this.level === 0 && !this.node?.expanded) {
        return false;
      }
      if (this.node?.expanded) {
        this.collapse(event);
        return;
      }
      let parentNodeElement = this.getParentNodeElement(nodeElement.parentElement);
      if (parentNodeElement) {
        this.focusRowChange(event.currentTarget, parentNodeElement);
      }
      event.preventDefault();
    }
    onEnter(event) {
      this.tree.onNodeClick(event, this.node);
      this.setTabIndexForSelectionMode(event, this.tree.nodeTouched);
      event.preventDefault();
    }
    setAllNodesTabIndexes() {
      const nodes = find(this.tree.el.nativeElement, '.p-tree-node');
      const hasSelectedNode = [...nodes].some(node => node.getAttribute('aria-selected') === 'true' || node.getAttribute('aria-checked') === 'true');
      [...nodes].forEach(node => {
        node.tabIndex = -1;
      });
      if (hasSelectedNode) {
        const selectedNodes = [...nodes].filter(node => node.getAttribute('aria-selected') === 'true' || node.getAttribute('aria-checked') === 'true');
        selectedNodes[0].tabIndex = 0;
        return;
      }
      if (nodes.length) {
        [...nodes][0].tabIndex = 0;
      }
    }
    setTabIndexForSelectionMode(event, nodeTouched) {
      if (this.tree.selectionMode !== null) {
        const elements = [...find(this.tree.el.nativeElement, '[role="treeitem"]')];
        event.currentTarget.tabIndex = nodeTouched === false ? -1 : 0;
        if (elements.every(element => element.tabIndex === -1)) {
          elements[0].tabIndex = 0;
        }
      }
    }
    findNextSiblingOfAncestor(nodeElement) {
      let parentNodeElement = this.getParentNodeElement(nodeElement);
      if (parentNodeElement) {
        if (parentNodeElement.nextElementSibling) return parentNodeElement.nextElementSibling;else return this.findNextSiblingOfAncestor(parentNodeElement);
      } else {
        return null;
      }
    }
    findLastVisibleDescendant(nodeElement) {
      const listElement = Array.from(nodeElement.children).find(el => hasClass(el, 'p-tree-node'));
      const childrenListElement = listElement?.children[1];
      if (childrenListElement && childrenListElement.children.length > 0) {
        const lastChildElement = childrenListElement.children[childrenListElement.children.length - 1];
        return this.findLastVisibleDescendant(lastChildElement);
      } else {
        return nodeElement;
      }
    }
    getParentNodeElement(nodeElement) {
      const parentNodeElement = nodeElement.parentElement?.parentElement?.parentElement;
      return parentNodeElement?.tagName === 'P-TREENODE' ? parentNodeElement : null;
    }
    focusNode(element) {
      if (this.tree.droppableNodes) element.children[1].focus();else element.children[0].focus();
    }
    focusRowChange(firstFocusableRow, currentFocusedRow, lastVisibleDescendant) {
      firstFocusableRow.tabIndex = '-1';
      currentFocusedRow.children[0].tabIndex = '0';
      this.focusNode(lastVisibleDescendant || currentFocusedRow);
    }
    focusVirtualNode() {
      this.timeout = setTimeout(() => {
        let node = findSingle(document.body, `[data-id="${this.node?.key ?? this.node?.data}"]`);
        focus(node);
      }, 1);
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵUITreeNode_BaseFactory;
      return function UITreeNode_Factory(__ngFactoryType__) {
        return (ɵUITreeNode_BaseFactory || (ɵUITreeNode_BaseFactory = i0.ɵɵgetInheritedFactory(UITreeNode)))(__ngFactoryType__ || UITreeNode);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: UITreeNode,
      selectors: [["p-treeNode"]],
      inputs: {
        rowNode: "rowNode",
        node: "node",
        parentNode: "parentNode",
        root: [2, "root", "root", booleanAttribute],
        index: [2, "index", "index", numberAttribute],
        firstChild: [2, "firstChild", "firstChild", booleanAttribute],
        lastChild: [2, "lastChild", "lastChild", booleanAttribute],
        level: [2, "level", "level", numberAttribute],
        indentation: [2, "indentation", "indentation", numberAttribute],
        itemSize: [2, "itemSize", "itemSize", numberAttribute],
        loadingMode: "loadingMode"
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["icon", ""], ["class", "p-tree-node-droppoint", 3, "ngClass", "drop", "dragover", "dragenter", "dragleave", 4, "ngIf"], ["role", "treeitem", 3, "keydown", "ngClass", "ngStyle"], [3, "click", "contextmenu", "dblclick", "touchend", "drop", "dragover", "dragenter", "dragleave", "dragstart", "dragend", "ngClass", "draggable"], ["type", "button", "pRipple", "", "tabindex", "-1", 1, "p-tree-node-toggle-button", 3, "click"], [4, "ngIf"], ["class", "p-tree-node-toggle-icon", 4, "ngIf"], ["styleClass", "p-tree-node-checkbox", 3, "ngModel", "binary", "indeterminate", "disabled", "variant", "tabindex", "click", 4, "ngIf"], [3, "class", 4, "ngIf"], [1, "p-tree-node-label"], ["class", "p-tree-node-children", "style", "display: none;", "role", "group", 3, "display", 4, "ngIf"], [1, "p-tree-node-droppoint", 3, "drop", "dragover", "dragenter", "dragleave", "ngClass"], [3, "styleClass", 4, "ngIf"], [3, "styleClass"], [1, "p-tree-node-toggle-icon"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["styleClass", "p-tree-node-checkbox", 3, "click", "ngModel", "binary", "indeterminate", "disabled", "variant", "tabindex"], ["role", "group", 1, "p-tree-node-children", 2, "display", "none"], [3, "node", "parentNode", "firstChild", "lastChild", "index", "itemSize", "level", "loadingMode", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "node", "parentNode", "firstChild", "lastChild", "index", "itemSize", "level", "loadingMode"]],
      template: function UITreeNode_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, UITreeNode_Conditional_0_Template, 13, 31);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.node ? 0 : -1);
        }
      },
      dependencies: [UITreeNode, CommonModule, i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgStyle, Ripple, Checkbox, FormsModule, i2.NgControlStatus, i2.NgModel, ChevronRightIcon, ChevronDownIcon, SpinnerIcon, SharedModule],
      encapsulation: 2
    });
  }
  return UITreeNode;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Tree is used to display hierarchical data.
 * @group Components
 */
let Tree = /*#__PURE__*/(() => {
  class Tree extends BaseComponent {
    dragDropService;
    /**
     * An array of treenodes.
     * @group Props
     */
    value;
    /**
     * Defines the selection mode.
     * @group Props
     */
    selectionMode;
    /**
     * Loading mode display.
     * @group Props
     */
    loadingMode = 'mask';
    /**
     * A single treenode instance or an array to refer to the selections.
     * @group Props
     */
    selection;
    /**
     * Inline style of the component.
     * @group Props
     */
    style;
    /**
     * Style class of the component.
     * @group Props
     */
    styleClass;
    /**
     * Context menu instance.
     * @group Props
     */
    contextMenu;
    /**
     * Scope of the draggable nodes to match a droppableScope.
     * @group Props
     */
    draggableScope;
    /**
     * Scope of the droppable nodes to match a draggableScope.
     * @group Props
     */
    droppableScope;
    /**
     * Whether the nodes are draggable.
     * @group Props
     */
    draggableNodes;
    /**
     * Whether the nodes are droppable.
     * @group Props
     */
    droppableNodes;
    /**
     * Defines how multiple items can be selected, when true metaKey needs to be pressed to select or unselect an item and when set to false selection of each item can be toggled individually. On touch enabled devices, metaKeySelection is turned off automatically.
     * @group Props
     */
    metaKeySelection = false;
    /**
     * Whether checkbox selections propagate to ancestor nodes.
     * @group Props
     */
    propagateSelectionUp = true;
    /**
     * Whether checkbox selections propagate to descendant nodes.
     * @group Props
     */
    propagateSelectionDown = true;
    /**
     * Displays a loader to indicate data load is in progress.
     * @group Props
     */
    loading;
    /**
     * The icon to show while indicating data load is in progress.
     * @group Props
     */
    loadingIcon;
    /**
     * Text to display when there is no data.
     * @group Props
     */
    emptyMessage = '';
    /**
     * Used to define a string that labels the tree.
     * @group Props
     */
    ariaLabel;
    /**
     * Defines a string that labels the toggler icon for accessibility.
     * @group Props
     */
    togglerAriaLabel;
    /**
     * Establishes relationships between the component and label(s) where its value should be one or more element IDs.
     * @group Props
     */
    ariaLabelledBy;
    /**
     * When enabled, drop can be accepted or rejected based on condition defined at onNodeDrop.
     * @group Props
     */
    validateDrop;
    /**
     * When specified, displays an input field to filter the items.
     * @group Props
     */
    filter;
    /**
     * Determines whether the filter input should be automatically focused when the component is rendered.
     * @group Props
     */
    filterInputAutoFocus = false;
    /**
     * When filtering is enabled, filterBy decides which field or fields (comma separated) to search against.
     * @group Props
     */
    filterBy = 'label';
    /**
     * Mode for filtering valid values are "lenient" and "strict". Default is lenient.
     * @group Props
     */
    filterMode = 'lenient';
    /**
     * Mode for filtering valid values are "lenient" and "strict". Default is lenient.
     * @group Props
     */
    filterOptions;
    /**
     * Placeholder text to show when filter input is empty.
     * @group Props
     */
    filterPlaceholder;
    /**
     * Values after the tree nodes are filtered.
     * @group Props
     */
    filteredNodes;
    /**
     * Locale to use in filtering. The default locale is the host environment's current locale.
     * @group Props
     */
    filterLocale;
    /**
     * Height of the scrollable viewport.
     * @group Props
     */
    scrollHeight;
    /**
     * Defines if data is loaded and interacted with in lazy manner.
     * @group Props
     */
    lazy = false;
    /**
     * Whether the data should be loaded on demand during scroll.
     * @group Props
     */
    virtualScroll;
    /**
     * Height of an item in the list for VirtualScrolling.
     * @group Props
     */
    virtualScrollItemSize;
    /**
     * Whether to use the scroller feature. The properties of scroller component can be used like an object in it.
     * @group Props
     */
    virtualScrollOptions;
    /**
     * Indentation factor for spacing of the nested node when virtual scrolling is enabled.
     * @group Props
     */
    indentation = 1.5;
    /**
     * Custom templates of the component.
     * @group Props
     */
    _templateMap;
    /**
     * Function to optimize the node list rendering, default algorithm checks for object identity.
     * @group Props
     */
    trackBy = (index, item) => item;
    /**
     * Highlights the node on select.
     * @group Props
     */
    highlightOnSelect = false;
    /**
     * Height of the node.
     * @group Props
     * @deprecated use virtualScrollItemSize property instead.
     */
    _virtualNodeHeight;
    get virtualNodeHeight() {
      return this._virtualNodeHeight;
    }
    set virtualNodeHeight(val) {
      this._virtualNodeHeight = val;
      console.log('The virtualNodeHeight property is deprecated, use virtualScrollItemSize property instead.');
    }
    /**
     * Callback to invoke on selection change.
     * @param {(TreeNode<any> | TreeNode<any>[] | null)} event - Custom selection change event.
     * @group Emits
     */
    selectionChange = new EventEmitter();
    /**
     * Callback to invoke when a node is selected.
     * @param {TreeNodeSelectEvent} event - Node select event.
     * @group Emits
     */
    onNodeSelect = new EventEmitter();
    /**
     * Callback to invoke when a node is unselected.
     * @param {TreeNodeUnSelectEvent} event - Node unselect event.
     * @group Emits
     */
    onNodeUnselect = new EventEmitter();
    /**
     * Callback to invoke when a node is expanded.
     * @param {TreeNodeExpandEvent} event - Node expand event.
     * @group Emits
     */
    onNodeExpand = new EventEmitter();
    /**
     * Callback to invoke when a node is collapsed.
     * @param {TreeNodeCollapseEvent} event - Node collapse event.
     * @group Emits
     */
    onNodeCollapse = new EventEmitter();
    /**
     * Callback to invoke when a node is selected with right click.
     * @param {onNodeContextMenuSelect} event - Node context menu select event.
     * @group Emits
     */
    onNodeContextMenuSelect = new EventEmitter();
    /**
     * Callback to invoke when a node is double clicked.
     * @param {TreeNodeDoubleClickEvent} event - Node double click event.
     * @group Emits
     */
    onNodeDoubleClick = new EventEmitter();
    /**
     * Callback to invoke when a node is dropped.
     * @param {TreeNodeDropEvent} event - Node drop event.
     * @group Emits
     */
    onNodeDrop = new EventEmitter();
    /**
     * Callback to invoke in lazy mode to load new data.
     * @param {TreeLazyLoadEvent} event - Custom lazy load event.
     * @group Emits
     */
    onLazyLoad = new EventEmitter();
    /**
     * Callback to invoke in virtual scroll mode when scroll position changes.
     * @param {TreeScrollEvent} event - Custom scroll event.
     * @group Emits
     */
    onScroll = new EventEmitter();
    /**
     * Callback to invoke in virtual scroll mode when scroll position and item's range in view changes.
     * @param {TreeScrollIndexChangeEvent} event - Scroll index change event.
     * @group Emits
     */
    onScrollIndexChange = new EventEmitter();
    /**
     * Callback to invoke when data is filtered.
     * @param {TreeFilterEvent} event - Custom filter event.
     * @group Emits
     */
    onFilter = new EventEmitter();
    /**
     * Filter template.
     * @group Templates
     */
    filterTemplate;
    /**
     * Node template.
     * @group Templates
     */
    nodeTemplate;
    /**
     * Header template.
     * @group Templates
     */
    headerTemplate;
    /**
     * Footer template.
     * @group Templates
     */
    footerTemplate;
    /**
     * Loader template.
     * @group Templates
     */
    loaderTemplate;
    /**
     * Empty message template.
     * @group Templates
     */
    emptyMessageTemplate;
    /**
     * Toggler icon template.
     * @group Templates
     */
    togglerIconTemplate;
    /**
     * Checkbox icon template.
     * @group Templates
     */
    checkboxIconTemplate;
    /**
     * Loading icon template.
     * @group Templates
     */
    loadingIconTemplate;
    /**
     * Filter icon template.
     * @group Templates
     */
    filterIconTemplate;
    filterViewChild;
    scroller;
    wrapperViewChild;
    templates;
    _headerTemplate;
    _emptyMessageTemplate;
    _footerTemplate;
    _loaderTemplate;
    _togglerIconTemplate;
    _checkboxIconTemplate;
    _loadingIconTemplate;
    _filterIconTemplate;
    _filterTemplate;
    ngAfterContentInit() {
      if (this.templates.length) {
        this._templateMap = {};
      }
      this.templates.forEach(item => {
        switch (item.getType()) {
          case 'header':
            this._headerTemplate = item.template;
            break;
          case 'empty':
            this._emptyMessageTemplate = item.template;
            break;
          case 'footer':
            this._footerTemplate = item.template;
            break;
          case 'loader':
            this._loaderTemplate = item.template;
            break;
          case 'togglericon':
            this._togglerIconTemplate = item.template;
            break;
          case 'checkboxicon':
            this._checkboxIconTemplate = item.template;
            break;
          case 'loadingicon':
            this._loadingIconTemplate = item.template;
            break;
          case 'filtericon':
            this._filterIconTemplate = item.template;
            break;
          case 'filter':
            this._filterTemplate = item.template;
            break;
          default:
            this._templateMap[item.name] = item.template;
            break;
        }
      });
    }
    serializedValue;
    nodeTouched;
    dragNodeTree;
    dragNode;
    dragNodeSubNodes;
    dragNodeIndex;
    dragNodeScope;
    dragHover;
    dragStartSubscription;
    dragStopSubscription;
    _componentStyle = inject(TreeStyle);
    constructor(dragDropService) {
      super();
      this.dragDropService = dragDropService;
    }
    ngOnInit() {
      super.ngOnInit();
      if (this.filterBy) {
        this.filterOptions = {
          filter: value => this._filter(value),
          reset: () => this.resetFilter()
        };
      }
      if (this.droppableNodes) {
        this.dragStartSubscription = this.dragDropService.dragStart$.subscribe(event => {
          this.dragNodeTree = event.tree;
          this.dragNode = event.node;
          this.dragNodeSubNodes = event.subNodes;
          this.dragNodeIndex = event.index;
          this.dragNodeScope = event.scope;
        });
        this.dragStopSubscription = this.dragDropService.dragStop$.subscribe(event => {
          this.dragNodeTree = null;
          this.dragNode = null;
          this.dragNodeSubNodes = null;
          this.dragNodeIndex = null;
          this.dragNodeScope = null;
          this.dragHover = false;
        });
      }
    }
    ngOnChanges(simpleChange) {
      super.ngOnChanges(simpleChange);
      if (simpleChange.value) {
        this.updateSerializedValue();
        if (this.hasFilterActive()) {
          this._filter(this.filterViewChild.nativeElement.value);
        }
      }
    }
    get containerClass() {
      return this._componentStyle.classes.root({
        instance: this
      });
    }
    get emptyMessageLabel() {
      return this.emptyMessage || this.config.getTranslation(TranslationKeys.EMPTY_MESSAGE);
    }
    updateSerializedValue() {
      this.serializedValue = [];
      this.serializeNodes(null, this.getRootNode(), 0, true);
    }
    serializeNodes(parent, nodes, level, visible) {
      if (nodes && nodes.length) {
        for (let node of nodes) {
          node.parent = parent;
          const rowNode = {
            node: node,
            parent: parent,
            level: level,
            visible: visible && (parent ? parent.expanded : true)
          };
          this.serializedValue.push(rowNode);
          if (rowNode.visible && node.expanded) {
            this.serializeNodes(node, node.children, level + 1, rowNode.visible);
          }
        }
      }
    }
    onNodeClick(event, node) {
      let eventTarget = event.target;
      if (hasClass(eventTarget, 'p-tree-toggler') || hasClass(eventTarget, 'p-tree-toggler-icon')) {
        return;
      } else if (this.selectionMode) {
        if (node.selectable === false) {
          node.style = '--p-focus-ring-color: none;';
          return;
        } else {
          if (!node.style?.includes('--p-focus-ring-color')) {
            node.style = node.style ? `${node.style}--p-focus-ring-color: var(--primary-color)` : '--p-focus-ring-color: var(--primary-color)';
          }
        }
        if (this.hasFilteredNodes()) {
          node = this.getNodeWithKey(node.key, this.filteredNodes);
          if (!node) {
            return;
          }
        }
        let index = this.findIndexInSelection(node);
        let selected = index >= 0;
        if (this.isCheckboxSelectionMode()) {
          if (selected) {
            if (this.propagateSelectionDown) this.propagateDown(node, false);else this.selection = this.selection.filter((val, i) => i != index);
            if (this.propagateSelectionUp && node.parent) {
              this.propagateUp(node.parent, false);
            }
            this.selectionChange.emit(this.selection);
            this.onNodeUnselect.emit({
              originalEvent: event,
              node: node
            });
          } else {
            if (this.propagateSelectionDown) this.propagateDown(node, true);else this.selection = [...(this.selection || []), node];
            if (this.propagateSelectionUp && node.parent) {
              this.propagateUp(node.parent, true);
            }
            this.selectionChange.emit(this.selection);
            this.onNodeSelect.emit({
              originalEvent: event,
              node: node
            });
          }
        } else {
          let metaSelection = this.nodeTouched ? false : this.metaKeySelection;
          if (metaSelection) {
            let metaKey = event.metaKey || event.ctrlKey;
            if (selected && metaKey) {
              if (this.isSingleSelectionMode()) {
                this.selectionChange.emit(null);
              } else {
                this.selection = this.selection.filter((val, i) => i != index);
                this.selectionChange.emit(this.selection);
              }
              this.onNodeUnselect.emit({
                originalEvent: event,
                node: node
              });
            } else {
              if (this.isSingleSelectionMode()) {
                this.selectionChange.emit(node);
              } else if (this.isMultipleSelectionMode()) {
                this.selection = !metaKey ? [] : this.selection || [];
                this.selection = [...this.selection, node];
                this.selectionChange.emit(this.selection);
              }
              this.onNodeSelect.emit({
                originalEvent: event,
                node: node
              });
            }
          } else {
            if (this.isSingleSelectionMode()) {
              if (selected) {
                this.selection = null;
                this.onNodeUnselect.emit({
                  originalEvent: event,
                  node: node
                });
              } else {
                this.selection = node;
                setTimeout(() => {
                  this.onNodeSelect.emit({
                    originalEvent: event,
                    node: node
                  });
                });
              }
            } else {
              if (selected) {
                this.selection = this.selection.filter((val, i) => i != index);
                this.onNodeUnselect.emit({
                  originalEvent: event,
                  node: node
                });
              } else {
                this.selection = [...(this.selection || []), node];
                setTimeout(() => {
                  this.onNodeSelect.emit({
                    originalEvent: event,
                    node: node
                  });
                });
              }
            }
            this.selectionChange.emit(this.selection);
          }
        }
      }
      this.nodeTouched = false;
    }
    onNodeTouchEnd() {
      this.nodeTouched = true;
    }
    onNodeRightClick(event, node) {
      if (this.contextMenu) {
        let eventTarget = event.target;
        if (eventTarget.className && eventTarget.className.indexOf('p-tree-toggler') === 0) {
          return;
        } else {
          let index = this.findIndexInSelection(node);
          let selected = index >= 0;
          if (!selected) {
            if (this.isSingleSelectionMode()) this.selectionChange.emit(node);else this.selectionChange.emit([node]);
          }
          this.contextMenu.show(event);
          this.onNodeContextMenuSelect.emit({
            originalEvent: event,
            node: node
          });
        }
      }
    }
    onNodeDblClick(event, node) {
      this.onNodeDoubleClick.emit({
        originalEvent: event,
        node: node
      });
    }
    findIndexInSelection(node) {
      let index = -1;
      if (this.selectionMode && this.selection) {
        if (this.isSingleSelectionMode()) {
          let areNodesEqual = this.selection.key && this.selection.key === node.key || this.selection == node;
          index = areNodesEqual ? 0 : -1;
        } else {
          for (let i = 0; i < this.selection.length; i++) {
            let selectedNode = this.selection[i];
            let areNodesEqual = selectedNode.key && selectedNode.key === node.key || selectedNode == node;
            if (areNodesEqual) {
              index = i;
              break;
            }
          }
        }
      }
      return index;
    }
    syncNodeOption(node, parentNodes, option, value) {
      // to synchronize the node option between the filtered nodes and the original nodes(this.value)
      const _node = this.hasFilteredNodes() ? this.getNodeWithKey(node.key, parentNodes) : null;
      if (_node) {
        _node[option] = value || node[option];
      }
    }
    hasFilteredNodes() {
      return this.filter && this.filteredNodes && this.filteredNodes.length;
    }
    hasFilterActive() {
      return this.filter && this.filterViewChild?.nativeElement?.value.length > 0;
    }
    getNodeWithKey(key, nodes) {
      for (let node of nodes) {
        if (node.key === key) {
          return node;
        }
        if (node.children) {
          let matchedNode = this.getNodeWithKey(key, node.children);
          if (matchedNode) {
            return matchedNode;
          }
        }
      }
    }
    propagateUp(node, select) {
      if (node.children && node.children.length) {
        let selectedCount = 0;
        let childPartialSelected = false;
        for (let child of node.children) {
          if (this.isSelected(child)) {
            selectedCount++;
          } else if (child.partialSelected) {
            childPartialSelected = true;
          }
        }
        if (select && selectedCount == node.children.length) {
          this.selection = [...(this.selection || []), node];
          node.partialSelected = false;
        } else {
          if (!select) {
            let index = this.findIndexInSelection(node);
            if (index >= 0) {
              this.selection = this.selection.filter((val, i) => i != index);
            }
          }
          if (childPartialSelected || selectedCount > 0 && selectedCount != node.children.length) node.partialSelected = true;else node.partialSelected = false;
        }
        this.syncNodeOption(node, this.filteredNodes, 'partialSelected');
      }
      let parent = node.parent;
      if (parent) {
        this.propagateUp(parent, select);
      }
    }
    propagateDown(node, select) {
      let index = this.findIndexInSelection(node);
      if (select && index == -1) {
        this.selection = [...(this.selection || []), node];
      } else if (!select && index > -1) {
        this.selection = this.selection.filter((val, i) => i != index);
      }
      node.partialSelected = false;
      this.syncNodeOption(node, this.filteredNodes, 'partialSelected');
      if (node.children && node.children.length) {
        for (let child of node.children) {
          this.propagateDown(child, select);
        }
      }
    }
    isSelected(node) {
      return this.findIndexInSelection(node) != -1;
    }
    isSingleSelectionMode() {
      return this.selectionMode && this.selectionMode == 'single';
    }
    isMultipleSelectionMode() {
      return this.selectionMode && this.selectionMode == 'multiple';
    }
    isCheckboxSelectionMode() {
      return this.selectionMode && this.selectionMode == 'checkbox';
    }
    isNodeLeaf(node) {
      return node.leaf == false ? false : !(node.children && node.children.length);
    }
    getRootNode() {
      return this.filteredNodes ? this.filteredNodes : this.value;
    }
    getTemplateForNode(node) {
      if (this._templateMap) return node.type ? this._templateMap[node.type] : this._templateMap['default'];else return null;
    }
    onDragOver(event) {
      if (this.droppableNodes && (!this.value || this.value.length === 0)) {
        event.dataTransfer.dropEffect = 'move';
        event.preventDefault();
      }
    }
    onDrop(event) {
      if (this.droppableNodes && (!this.value || this.value.length === 0)) {
        event.preventDefault();
        let dragNode = this.dragNode;
        if (this.allowDrop(dragNode, null, this.dragNodeScope)) {
          let dragNodeIndex = this.dragNodeIndex;
          this.value = this.value || [];
          if (this.validateDrop) {
            this.onNodeDrop.emit({
              originalEvent: event,
              dragNode: dragNode,
              dropNode: null,
              index: dragNodeIndex,
              accept: () => {
                this.processTreeDrop(dragNode, dragNodeIndex);
              }
            });
          } else {
            this.onNodeDrop.emit({
              originalEvent: event,
              dragNode: dragNode,
              dropNode: null,
              index: dragNodeIndex
            });
            this.processTreeDrop(dragNode, dragNodeIndex);
          }
        }
      }
    }
    processTreeDrop(dragNode, dragNodeIndex) {
      this.dragNodeSubNodes.splice(dragNodeIndex, 1);
      this.value.push(dragNode);
      this.dragDropService.stopDrag({
        node: dragNode
      });
    }
    onDragEnter() {
      if (this.droppableNodes && this.allowDrop(this.dragNode, null, this.dragNodeScope)) {
        this.dragHover = true;
      }
    }
    onDragLeave(event) {
      if (this.droppableNodes) {
        let rect = event.currentTarget.getBoundingClientRect();
        if (event.x > rect.left + rect.width || event.x < rect.left || event.y > rect.top + rect.height || event.y < rect.top) {
          this.dragHover = false;
        }
      }
    }
    allowDrop(dragNode, dropNode, dragNodeScope) {
      if (!dragNode) {
        //prevent random html elements to be dragged
        return false;
      } else if (this.isValidDragScope(dragNodeScope)) {
        let allow = true;
        if (dropNode) {
          if (dragNode === dropNode) {
            allow = false;
          } else {
            let parent = dropNode.parent;
            while (parent != null) {
              if (parent === dragNode) {
                allow = false;
                break;
              }
              parent = parent.parent;
            }
          }
        }
        return allow;
      } else {
        return false;
      }
    }
    isValidDragScope(dragScope) {
      let dropScope = this.droppableScope;
      if (dropScope) {
        if (typeof dropScope === 'string') {
          if (typeof dragScope === 'string') return dropScope === dragScope;else if (Array.isArray(dragScope)) return dragScope.indexOf(dropScope) != -1;
        } else if (Array.isArray(dropScope)) {
          if (typeof dragScope === 'string') {
            return dropScope.indexOf(dragScope) != -1;
          } else if (Array.isArray(dragScope)) {
            for (let s of dropScope) {
              for (let ds of dragScope) {
                if (s === ds) {
                  return true;
                }
              }
            }
          }
        }
        return false;
      } else {
        return true;
      }
    }
    _filter(value) {
      let filterValue = value;
      if (filterValue === '') {
        this.filteredNodes = null;
      } else {
        this.filteredNodes = [];
        const searchFields = this.filterBy.split(',');
        const filterText = removeAccents(filterValue).toLocaleLowerCase(this.filterLocale);
        const isStrictMode = this.filterMode === 'strict';
        for (let node of this.value) {
          let copyNode = {
            ...node
          };
          let paramsWithoutNode = {
            searchFields,
            filterText,
            isStrictMode
          };
          if (isStrictMode && (this.findFilteredNodes(copyNode, paramsWithoutNode) || this.isFilterMatched(copyNode, paramsWithoutNode)) || !isStrictMode && (this.isFilterMatched(copyNode, paramsWithoutNode) || this.findFilteredNodes(copyNode, paramsWithoutNode))) {
            this.filteredNodes.push(copyNode);
          }
        }
      }
      this.updateSerializedValue();
      this.onFilter.emit({
        filter: filterValue,
        filteredValue: this.filteredNodes
      });
    }
    /**
     * Resets filter.
     * @group Method
     */
    resetFilter() {
      this.filteredNodes = null;
      if (this.filterViewChild && this.filterViewChild.nativeElement) {
        this.filterViewChild.nativeElement.value = '';
      }
    }
    /**
     * Scrolls to virtual index.
     * @param {number} number - Index to be scrolled.
     * @group Method
     */
    scrollToVirtualIndex(index) {
      this.virtualScroll && this.scroller?.scrollToIndex(index);
    }
    /**
     * Scrolls to virtual index.
     * @param {ScrollToOptions} options - Scroll options.
     * @group Method
     */
    scrollTo(options) {
      if (this.virtualScroll) {
        this.scroller?.scrollTo(options);
      } else if (this.wrapperViewChild && this.wrapperViewChild.nativeElement) {
        if (this.wrapperViewChild.nativeElement.scrollTo) {
          this.wrapperViewChild.nativeElement.scrollTo(options);
        } else {
          this.wrapperViewChild.nativeElement.scrollLeft = options.left;
          this.wrapperViewChild.nativeElement.scrollTop = options.top;
        }
      }
    }
    findFilteredNodes(node, paramsWithoutNode) {
      if (node) {
        let matched = false;
        if (node.children) {
          let childNodes = [...node.children];
          node.children = [];
          for (let childNode of childNodes) {
            let copyChildNode = {
              ...childNode
            };
            if (this.isFilterMatched(copyChildNode, paramsWithoutNode)) {
              matched = true;
              node.children.push(copyChildNode);
            }
          }
        }
        if (matched) {
          node.expanded = true;
          return true;
        }
      }
    }
    isFilterMatched(node, params) {
      let {
        searchFields,
        filterText,
        isStrictMode
      } = params;
      let matched = false;
      for (let field of searchFields) {
        let fieldValue = removeAccents(String(resolveFieldData(node, field))).toLocaleLowerCase(this.filterLocale);
        if (fieldValue.indexOf(filterText) > -1) {
          matched = true;
        }
      }
      if (!matched || isStrictMode && !this.isNodeLeaf(node)) {
        matched = this.findFilteredNodes(node, {
          searchFields,
          filterText,
          isStrictMode
        }) || matched;
      }
      return matched;
    }
    getIndex(options, index) {
      const getItemOptions = options['getItemOptions'];
      return getItemOptions ? getItemOptions(index).index : index;
    }
    getBlockableElement() {
      return this.el.nativeElement.children[0];
    }
    ngOnDestroy() {
      if (this.dragStartSubscription) {
        this.dragStartSubscription.unsubscribe();
      }
      if (this.dragStopSubscription) {
        this.dragStopSubscription.unsubscribe();
      }
      super.ngOnDestroy();
    }
    static ɵfac = function Tree_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Tree)(i0.ɵɵdirectiveInject(i3.TreeDragDropService, 8));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Tree,
      selectors: [["p-tree"]],
      contentQueries: function Tree_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c5, 4);
          i0.ɵɵcontentQuery(dirIndex, _c6, 4);
          i0.ɵɵcontentQuery(dirIndex, _c7, 4);
          i0.ɵɵcontentQuery(dirIndex, _c8, 4);
          i0.ɵɵcontentQuery(dirIndex, _c9, 4);
          i0.ɵɵcontentQuery(dirIndex, _c10, 4);
          i0.ɵɵcontentQuery(dirIndex, _c11, 4);
          i0.ɵɵcontentQuery(dirIndex, _c12, 4);
          i0.ɵɵcontentQuery(dirIndex, _c13, 4);
          i0.ɵɵcontentQuery(dirIndex, _c14, 4);
          i0.ɵɵcontentQuery(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nodeTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loaderTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emptyMessageTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.togglerIconTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.checkboxIconTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loadingIconTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterIconTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      viewQuery: function Tree_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c5, 5);
          i0.ɵɵviewQuery(_c15, 5);
          i0.ɵɵviewQuery(_c16, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterViewChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scroller = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.wrapperViewChild = _t.first);
        }
      },
      inputs: {
        value: "value",
        selectionMode: "selectionMode",
        loadingMode: "loadingMode",
        selection: "selection",
        style: "style",
        styleClass: "styleClass",
        contextMenu: "contextMenu",
        draggableScope: "draggableScope",
        droppableScope: "droppableScope",
        draggableNodes: [2, "draggableNodes", "draggableNodes", booleanAttribute],
        droppableNodes: [2, "droppableNodes", "droppableNodes", booleanAttribute],
        metaKeySelection: [2, "metaKeySelection", "metaKeySelection", booleanAttribute],
        propagateSelectionUp: [2, "propagateSelectionUp", "propagateSelectionUp", booleanAttribute],
        propagateSelectionDown: [2, "propagateSelectionDown", "propagateSelectionDown", booleanAttribute],
        loading: [2, "loading", "loading", booleanAttribute],
        loadingIcon: "loadingIcon",
        emptyMessage: "emptyMessage",
        ariaLabel: "ariaLabel",
        togglerAriaLabel: "togglerAriaLabel",
        ariaLabelledBy: "ariaLabelledBy",
        validateDrop: [2, "validateDrop", "validateDrop", booleanAttribute],
        filter: [2, "filter", "filter", booleanAttribute],
        filterInputAutoFocus: [2, "filterInputAutoFocus", "filterInputAutoFocus", booleanAttribute],
        filterBy: "filterBy",
        filterMode: "filterMode",
        filterOptions: "filterOptions",
        filterPlaceholder: "filterPlaceholder",
        filteredNodes: "filteredNodes",
        filterLocale: "filterLocale",
        scrollHeight: "scrollHeight",
        lazy: [2, "lazy", "lazy", booleanAttribute],
        virtualScroll: [2, "virtualScroll", "virtualScroll", booleanAttribute],
        virtualScrollItemSize: [2, "virtualScrollItemSize", "virtualScrollItemSize", numberAttribute],
        virtualScrollOptions: "virtualScrollOptions",
        indentation: [2, "indentation", "indentation", numberAttribute],
        _templateMap: "_templateMap",
        trackBy: "trackBy",
        highlightOnSelect: [2, "highlightOnSelect", "highlightOnSelect", booleanAttribute],
        virtualNodeHeight: "virtualNodeHeight"
      },
      outputs: {
        selectionChange: "selectionChange",
        onNodeSelect: "onNodeSelect",
        onNodeUnselect: "onNodeUnselect",
        onNodeExpand: "onNodeExpand",
        onNodeCollapse: "onNodeCollapse",
        onNodeContextMenuSelect: "onNodeContextMenuSelect",
        onNodeDoubleClick: "onNodeDoubleClick",
        onNodeDrop: "onNodeDrop",
        onLazyLoad: "onLazyLoad",
        onScroll: "onScroll",
        onScrollIndexChange: "onScrollIndexChange",
        onFilter: "onFilter"
      },
      features: [i0.ɵɵProvidersFeature([TreeStyle]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
      decls: 8,
      vars: 10,
      consts: [["filter", ""], ["scroller", ""], ["content", ""], ["treeNode", ""], ["loader", ""], ["wrapper", ""], ["emptyFilter", ""], [3, "drop", "dragover", "dragenter", "dragleave", "ngClass", "ngStyle"], ["class", "p-tree-mask p-overlay-mask", 4, "ngIf"], [4, "ngTemplateOutlet"], [4, "ngIf"], ["class", "p-tree-empty-message", 4, "ngIf"], [1, "p-tree-mask", "p-overlay-mask"], [3, "class", 4, "ngIf"], [3, "spin", "styleClass", 4, "ngIf"], ["class", "p-tree-loading-icon", 4, "ngIf"], [3, "spin", "styleClass"], [1, "p-tree-loading-icon"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["pInputText", "", "type", "search", "autocomplete", "off", 1, "p-tree-filter-input", 3, "keydown.enter", "input", "pAutoFocus"], ["class", "p-tree-filter-icon", 4, "ngIf"], [1, "p-tree-filter-icon"], ["styleClass", "p-tree-root", 3, "items", "tabindex", "style", "scrollHeight", "itemSize", "lazy", "options", "onScroll", "onScrollIndexChange", "onLazyLoad", 4, "ngIf"], ["styleClass", "p-tree-root", 3, "onScroll", "onScrollIndexChange", "onLazyLoad", "items", "tabindex", "scrollHeight", "itemSize", "lazy", "options"], ["class", "p-tree-root-children", "role", "tree", 3, "ngClass", "style", 4, "ngIf"], ["role", "tree", 1, "p-tree-root-children", 3, "ngClass"], [3, "level", "rowNode", "node", "parentNode", "firstChild", "lastChild", "index", "itemSize", "indentation", "loadingMode", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "level", "rowNode", "node", "parentNode", "firstChild", "lastChild", "index", "itemSize", "indentation", "loadingMode"], [1, "p-tree-root"], ["class", "p-tree-root-children", "role", "tree", 4, "ngIf"], ["role", "tree", 1, "p-tree-root-children"], [3, "node", "firstChild", "lastChild", "index", "level", "loadingMode", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "node", "firstChild", "lastChild", "index", "level", "loadingMode"], [1, "p-tree-empty-message"], [4, "ngIf", "ngIfElse"]],
      template: function Tree_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 7);
          i0.ɵɵlistener("drop", function Tree_Template_div_drop_0_listener($event) {
            return ctx.onDrop($event);
          })("dragover", function Tree_Template_div_dragover_0_listener($event) {
            return ctx.onDragOver($event);
          })("dragenter", function Tree_Template_div_dragenter_0_listener() {
            return ctx.onDragEnter();
          })("dragleave", function Tree_Template_div_dragleave_0_listener($event) {
            return ctx.onDragLeave($event);
          });
          i0.ɵɵtemplate(1, Tree_div_1_Template, 3, 2, "div", 8)(2, Tree_ng_container_2_Template, 1, 0, "ng-container", 9)(3, Tree_Conditional_3_Template, 1, 4, "ng-container")(4, Tree_Conditional_4_Template, 1, 1, "p-iconField")(5, Tree_ng_container_5_Template, 3, 2, "ng-container", 10)(6, Tree_div_6_Template, 3, 3, "div", 11)(7, Tree_ng_container_7_Template, 1, 0, "ng-container", 9);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          let tmp_6_0;
          i0.ɵɵclassMap(ctx.styleClass);
          i0.ɵɵproperty("ngClass", ctx.containerClass)("ngStyle", ctx.style);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.loading && ctx.loadingMode === "mask");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", ctx.headerTemplate || ctx._headerTemplate);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.filterTemplate || ctx._filterTemplate ? 3 : 4);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", (tmp_6_0 = ctx.getRootNode()) == null ? null : tmp_6_0.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.loading && (ctx.getRootNode() == null || ctx.getRootNode().length === 0));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", ctx.footerTemplate || ctx._footerTemplate);
        }
      },
      dependencies: [CommonModule, i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgStyle, Scroller, SharedModule, SearchIcon, SpinnerIcon, InputText, FormsModule, IconField, InputIcon, UITreeNode, AutoFocusModule, i4.AutoFocus],
      encapsulation: 2
    });
  }
  return Tree;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TreeModule = /*#__PURE__*/(() => {
  class TreeModule {
    static ɵfac = function TreeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TreeModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TreeModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [Tree, SharedModule, SharedModule]
    });
  }
  return TreeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Tree, TreeClasses, TreeModule, TreeStyle, UITreeNode };
